import React from "react"
import { ITimecardPriorPeriodData, ITimecardWeek, ELoggedInUserType } from "../../models"
import AccountStore from "../../stores/AccountStore"
import * as colorHelper from "../../helpers/colorHelper"
import AuthenticationStore from "../../stores/AuthenticationStore"
import * as permissionHelper from "../../helpers/permissionHelper"
import strings from "../../localization/strings"

interface IProps {
	filterByPunchHierarchy: boolean
	timecardWeek: ITimecardWeek
	timecardPriorPeriodData: ITimecardPriorPeriodData
	priorPeriodAdjustMode: boolean
	allowPriorPeriodAdjust: boolean
	loggedInUserType: ELoggedInUserType
	blendedOvertimeRate: number
}

const EmployeeTimecardGrandTotalRow: React.SFC<IProps> = (props: IProps) => {
	var formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	});

	const color = colorHelper.getTimecardPrimaryColor(props.timecardPriorPeriodData)

	return (
		<div className="EmployeeTimecardGrandTotalRow"
			style={{
				backgroundColor: props.priorPeriodAdjustMode && !props.allowPriorPeriodAdjust ? "#EFEFEF" : "white",
				borderTop: ("solid 3px " + color),
				borderBottom: "",
				paddingLeft: 25
			}}
		>
			<div style={{ color: color, paddingTop: 15 }}>{strings.Week_Totals}</div>
			<table style={{ color: color, paddingTop: 3, paddingBottom: 20 }}>
				<tbody>
					<tr>
						<td style={{ paddingRight: 10 }}>Total:</td>
						<td>{`${props.timecardWeek.TimeTotals.TotalHours} hrs`}</td>
					</tr>
					<tr>
						<td style={{ paddingRight: 10 }}>Working Total:</td>
						<td>{`${props.timecardWeek.TimeTotals.TotalProductiveHours} hrs`}</td>
					</tr>
					{!props.filterByPunchHierarchy && [
						<tr key="Reg">
							<td style={{ paddingRight: 10 }}>Reg:</td>
							<td>{`${props.timecardWeek.TimeTotals.RegularHours} hrs`}</td>
						</tr>,
						<tr key="OT1">
							<td style={{ paddingRight: 10 }}>OT1:</td>
							<td>{`${props.timecardWeek.TimeTotals.OvertimeHours} hrs`}</td>
						</tr>,
						!AccountStore.getHideOT2() &&
						<tr key="OT2">
							<td style={{ paddingRight: 10 }}>OT2:</td>
							<td>{`${props.timecardWeek.TimeTotals.DoubleOvertimeHours} hrs`}</td>
						</tr>,
						props.timecardWeek.TimeTotals && props.timecardWeek.TimeTotals.PayTypeTotals && props.timecardWeek.TimeTotals.PayTypeTotals.sort((a, b) => {
							if (a.PayTypeCode < b.PayTypeCode) return -1
							if (a.PayTypeCode > b.PayTypeCode) return 1
							return 0
						}).map((payTypeTotal, index) =>
							<tr key={index}>
								<td style={{ paddingRight: 10 }}>
									<span title={payTypeTotal.PayTypeName}>{payTypeTotal.PayTypeName}:</span>
								</td>
								<td>{`${payTypeTotal.TotalHours} hrs`}</td>
							</tr>
						)
					]}
				</tbody>
			</table>
			{AccountStore.getRateTotalsEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Account.ViewRates) &&
				<table style={{ borderTop: ("1px solid" + color), paddingTop: 10, color: color, paddingBottom: 20 }}>
					<tbody>
						{AccountStore.getBlendedOvertimeRateEnabled() && 
							<tr key="blendedRateTotal">
								<td>Blended OT Rate:</td>
								<td>{formatter.format(props.blendedOvertimeRate)}</td>
							</tr>
						}
						<tr key="payTotal">
							<td>Pay:</td>
							<td>{formatter.format(props.timecardWeek.PayTotal)}</td>
						</tr>
						{props.loggedInUserType !== ELoggedInUserType.Employee && [
							<tr key="burdenTotal">
								<td>Burden:</td>
								<td>{formatter.format(props.timecardWeek.BurdenTotal)}</td>
							</tr>,
							<tr key="billTotal">
								<td>Bill:</td>
								<td>{formatter.format(props.timecardWeek.BillTotal)}</td>
							</tr>,
							<tr key="netTotal">
								<td>Net:</td>
								<td>{formatter.format(props.timecardWeek.NetTotal)}</td>
							</tr>,
							<tr key="marginTotal">
								<td>Margin:</td>
								<td>{props.timecardWeek.MarginTotal}%</td>
							</tr>
						]}
					</tbody>
				</table>
			}
		</div>
	)
}

export default EmployeeTimecardGrandTotalRow
